<template>
  <section  class=" public-text1-b  mb-2">
        <router-link :to="item.to" class="text-grey-500"  v-for="(item,index) in breadcrumbs" :key="index" :aria-label="item.text">{{ item.text}}/&nbsp;</router-link>
         <span>{{ props.productName }} </span>
    </section>
   
</template>
<script setup>
import {ref,defineProps,onMounted,} from 'vue'
const props=defineProps({
category:{
 id:{type:Number,require:true},
 name:{type:String,require:true},
 slug:{type:String,require:true},
 sub_category:{type:Number,require:true}}
,productName:{type:String,require:true}
,chechCategory:{type:Boolean,require:true}
})
const categories=ref([])
const breadcrumbs=ref([])
const  generateBreadcrumbs=(x)=>{
 let currentCategory = x
 while (currentCategory) {
   breadcrumbs.value.unshift({ text: currentCategory.name, to: '/category'+'/'+ currentCategory.slug })
   currentCategory = categories.value.find(c => c.id === currentCategory.sub_category)
 }
 breadcrumbs.value.unshift({ text: 'خانه', to: '/'})
 return breadcrumbs
}

const isLoading=ref(true)
onMounted(()=>{
 if(props.chechCategory){
 generateBreadcrumbs(props.category)
 
 isLoading.value=false
}else{
 console.log('not fetch data')
}
})


</script>